<template>
    <section class="container fixed_bottom">
        <div class="d-flex align-items-center">
            <label for="copyReport" class="mr-2">複製此保障設定檔至：</label>
            
            <label for="copyReport" class="mr-2">API Type/Report Type：</label>
            <input
                id="copyReport"
                v-model="report"
                type="text"
                class="form-control form-control-inline mr-3 flex-grow-1"
            />
            
            <label for="copyReportName" class="mr-2">保障設定名稱：</label>
            <input
                id="copyReportName"
                v-model="report_name"
                type="text"
                maxlength="40"
                class="form-control form-control-inline mr-3 flex-grow-1"
            />
            
            <span v-if="!canCopy" class="small text-secondary text-right">
                *此設定檔尚未覆核生效<br>因此無法複製
            </span>
            <button type="button" class="btn btn-primary" @click="doCopy()" :disabled="!canCopy">開始複製</button>
        </div>
    </section>
</template>

<script>
import { copyReport } from "@/service";
export default {
    name: "ReportSettingFooter",
    props: {
        data: {
            type: Object, 
            required: true, 
            default: () => {}
        },
        canCopy: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            report: "",
            report_name: "",
        };
    },
    methods: {
        async doCopy() {
            if (this.report === "") {
                this.$toast.info({ title: "請輸入API Type/Report Type" });
                return;
            }
            if (this.report_name === "") {
                this.$toast.info({ title: "請輸入保障設定名稱" });
                return;
            }

            let copyData = {
                original_report: this.data.report,
                report: this.report,
                report_name: this.report_name,
                shell_level: this.data.shell_level,
                sum_position: this.data.sum_position,
                memo: "",
                status: "0",
                creator: this.data.creator,
                creatorname: this.data.creatorname,
            }
            await copyReport(this.userID, copyData).then((result) => {
                if (result.header && result.header.status == "200") {
                    this.$toast.info({ title: "保障設定複製成功" });
                    this.$router.push({ name: 'CoverageReportList' })
                } else if (result.header.status == "-2") {
                    this.$toast.info({ title: "type：" + this.report + "，已存在，不可重複新增" });
                } else {
                    this.$toast.info({ title: result.header.message });
                }
            });
        }
    },
    watch: {},
    mounted() {
      
    },
};
</script>

<style lang="scss" scoped>
.fixed_bottom {
    z-index: 999;
    position: fixed;
    bottom: 0;
    right: 0;
    max-width: 100%;
    padding: 25px 8%;
    background-color: #f5f5f5;
    box-shadow: rgb(158, 158, 158) 1px 3px 17px 0px;
}
</style>
